module.exports = __webpack_public_path__ + "img/5.708a53cb.png";